import { mapGetters } from "vuex";
import { required, maxLength, helpers } from "vuelidate/lib/validators";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import ConfirmModal from "../../views/InterviewProcess/ConfirmModal.vue";

import toast from "../../components/mixin/toast";

import {
  getfeedback,
  getperticularintprocess,
} from "../../utils/apiFunctions.js";

const interviewProcessMixins = {
  name: "interviewProcessMixins",
  components: {
    Spinner,
    ConfirmModal,
  },
  mixins: [toast],

  data: () => ({
    interviewResponse: {},
    interviewDetails: [],
    activatebtn: false,
    originalData: [],
    editName: "",
    editroundName: "",
    mobheader: "",
    button: "",
    msg: "",
    discardSkill: false,
    ipmodal: false,
    showJobType: false,
    prcomments: "Comments will be shown here",
    prscore: "Score will be given from 1 - 10",
    // NUMBERS
    selectedIndex: 0,
    enableFields: false,

    // STRINGS
    name: "",

    JobTitles: "",
    searchscore: "",
    duplicateName: false,

    // BOOLEAN
    hasDuplicateName: false,
    scoremodal: false,
    disable: true,
    LoaderStatus: false,

    checkRoundName: false,
    allNames: [],
    // hasChanges: false,

    // ARRAYS

    duplicateIndices: [],
    basicInfo: {
      name: "<Candidate name will be shown here>",
      evalDate: "<Evaluation date will be shown here>",

      panel: "<Panel name will be shown here>",
      modeOfInterview: "<Mode of interview will be shown here>",
    },
    tabs: [
      {
        id: null,
        name: "",
        type: null,
        feedbackform: {
          name: "",
          feedbackFormID: "",
        },
        duration: "",
        randomizeTest: false,
        roundIndex: null,
        duplicateName: false,

        testID: [],
      },
    ],
    screenshots: [
      {
        value: true,
        name: "Yes",
      },
      {
        value: false,
        name: "No",
      },
    ],
    feedbackform: [],
    roundtype: [
      {
        value: "assesment",
        text: "Assessment",
      },
      {
        value: "f2f",
        text: "Face To Face",
      },
    ],
  }),
  validations() {
    return {
      JobTitles: {
        required,
        maxLength: maxLength(128),
        alpha: helpers.regex("alpha", /^[A-Za-z0-9].*$/),
      },
      tabs: {
        $each: {
          name: {
            required,
            maxLength: maxLength(128),
            alpha: helpers.regex("alpha", /^[A-Za-z0-9].*$/),
          },
          type: {
            required,
          },
          feedbackform: {
            name: {
              required,
            },
          },
        },
      },
    };
  },
  watch: {
    searchscore(newValue, oldValue) {
      if (newValue != oldValue) {
        this.getallfeedbackforms();
      }
    },
    originalData() {},
  },

  computed: {
    ...mapGetters(["roles"]),
    ...mapGetters("scheduleInterviewVUEX", {
      Process: "getInterviewProcess",
      FeedbackFormData: "getFeedbackForm",
    }),
    hasChanges() {
      if (this.tabs.length !== this.originalData.length) {
        return true;
      }

      for (let i = 0; i < this.originalData.length; i++) {
        const originalItem = this.originalData[i];
        const tabItem = this.tabs[i];

        if (
          originalItem.name !== tabItem.name ||
          originalItem.type !== tabItem.type ||
          originalItem.feedbackform.name !== tabItem.feedbackform.name
        ) {
          return true;
        }
      }

      if (this.editName !== this.JobTitles) {
        return true;
      }

      return false;
    },
    scoreHeight() {
      let data;
      if (
        this.feedbackform.length == 0 ||
        this.feedbackform.length == 1 ||
        this.feedbackform.length == 2
      ) {
        data = 2;
      } else if (this.feedbackform.length == 3) {
        data = 3;
      } else {
        data = 4;
      }
      return data;
    },

    // HELPER METHOD FOR TOGGLING DELETE BUTTONS
    adddisableround() {
      return this.tabs.some((tab) => {
        return (
          tab.name === "" ||
          tab.type === "" ||
          tab.type === null ||
          tab.feedbackform.name === "" ||
          this.duplicateName ||
          (tab.duplicateName && this.duplicateIndices.length !== 0)
        );
      });
    },
  },

  methods: {
    openFeedBack() {
      this.ipmodal = true;
    },
    closeModal() {
      this.ipmodal = false;
    },
    async getintdata() {
      try {
        const res = await getperticularintprocess(
          this.$route.params.interviewProcessID
        );
        if (res.status == 200) {
          this.interviewResponse = res;
          this.JobTitles = res.data.data.name;
          this.editName = res.data.data.name;
          this.interviewDetails = res.data.data.process;

          this.originalData = JSON.parse(JSON.stringify(res.data.data.process));
          this.originalData = this.originalData.slice(
            1,
            this.originalData.length - 4
          );

          this.tabs.pop();
          this.interviewData();
        }
      } catch (error) {
        this.LoaderStatus = false;
        throw new Error(`Failed! status:${error.status}`);
      }
    },
    funcForOutsideClickForScoreCard() {
      this.scoremodal = false;
    },
    selectRoundValidation() {
      this.$v.tabs.$touch();
    },
    // CLOSE PREVIEW FEEDBACK FORM MODAL
    closepreviewmodal() {
      this.$bvModal.hide("ippreviewmodal");
    },
    // SELECT A ROUND
    selectRound(i) {
      if (i === this.tabs.length) {
        this.selectedIndex = i - 1;
      } else {
        this.selectedIndex = i;
      }

      this.$nextTick(() => {
        this.checkName(); // Use $nextTick to ensure Vue has updated the DOM
      });

      if (this.tabs[this.selectedIndex].roundIndex !== null) {
        this.tabs[this.selectedIndex].roundIndex = null;
      }
    },
    // CANCEL THE PROGRESS AND MOVE BACK
    cancel() {
      this.clearform();
      this.$router.push({
        name: "InterviewProcessDashboard",
        query: {
          type: this.$route.query.type,
          sort: this.$route.query.sort,
        },
      });
    },
    // CLEAR THE INTERVIEW PROCESS FORM
    clearform() {
      this.tabs = {
        id: this.tabs.length + 1,
        name: "",
        type: null,
        feedbackform: {
          name: "",
          feedbackFormID: "",
        },
        duration: "",
        randomizeTest: false,
        testID: [],
      };
      this.JobTitles = "";
    },
    newTab() {
      this.tabs.push({
        id: this.tabs.length + 1,
        name: "",
        type: null,
        feedbackform: {
          name: "",
          feedbackFormID: "",
        },

        duration: "",
        randomizeTest: false,
        testID: [],
      });
      for (let i = 0; i < this.tabs.length; i++) {
        if (
          this.tabs[i].name === "" ||
          this.tabs[i].type === null ||
          this.tabs[i].feedbackform === undefined
        ) {
          this.tabs[i].roundIndex = i;
          this.checkRoundName = true;
        } else {
          this.tabs[i].roundIndex = null;
          this.checkRoundName = false;
        }
      }
      this.selectRound(this.tabs.length - 1);
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    async getallfeedbackforms() {
      let payload = {
        type: 1,
        searchQuery: this.searchscore,
      };
      const response = await getfeedback(payload);
      if (response.status == 200) {
        this.feedbackform = response.data.data.reverse();
      }
    },
    gobackDashboard() {
      if (
        (this.hasChanges && this.activatebtn == false) ||
        this.$route.query.status == "feedbackGiven"
      ) {
        this.mobheader = "Discard Changes";
        this.button = "Discard";
        this.msg = "Are you sure you want to discard the data you entered?";
        this.$bvModal.show("confirmationmsg");
      } else if (!this.hasChanges || this.activatebtn) {
        this.goback();
      }
    },
    goback() {
      this.$router.push({
        name: "HiringProcessDashboard",
        query: {
          type: this.$route.query.type,
          sort: this.$route.query.sort,
          status: "interviewProcess",
        },
      });
    },
    checkName() {
      this.duplicateIndices = [];

      for (let i = 0; i < this.tabs.length; i++) {
        let selectedValue = this.tabs[i].name.toLowerCase();
        let hasDuplicate = false;

        if (selectedValue !== "") {
          for (let j = 0; j < this.tabs.length; j++) {
            if (i !== j && this.tabs[j].name.toLowerCase() === selectedValue) {
              hasDuplicate = true;
              this.duplicateIndices.push(i, j);
              // You can break the inner loop here if you want to highlight only one pair
            }
          }
        }

        this.tabs[i].duplicateName = hasDuplicate;
      }
    },
    openJobType() {
      this.showJobType = true;
    },
    openScoreType() {
      this.showJobType = false;

      this.scoremodal = true;
    },

    closeJobType() {
      this.showJobType = false;
    },
    removeRound(x) {
      this.tabs.splice(x, 1);
      for (let i = 0; i < this.tabs.length; i++) {
        this.tabs[i].id = i + 1;
      }
      this.selectedIndex = this.tabs.length - 1;
    },
    interviewData() {
      for (let n in this.interviewDetails) {
        if (
          this.interviewResponse.data.data.process[n].id != 0 &&
          this.interviewResponse.data.data.process[n].id != "F" &&
          this.interviewResponse.data.data.process[n].id != "H" &&
          this.interviewResponse.data.data.process[n].id != "NI" &&
          this.interviewResponse.data.data.process[n].id != "R"
        ) {
          let feedform = {};
          for (let k in this.feedbackform) {
            if (
              this.interviewResponse.data.data.process[n].feedbackFormID ==
              this.feedbackform[k].feedbackFormID
            ) {
              feedform = this.feedbackform[k];
              break;
            }
          }
          this.tabs.push({
            id: this.interviewResponse.data.data.process[n].id,
            name: this.interviewResponse.data.data.process[n].name,
            type: this.interviewResponse.data.data.process[n].type,
            feedbackform: feedform,
            duration: "",
            randomizeTest: false,
            testID: [],
          });
        }
      }
      this.selectRound(0);
    },
    checkDuplicate() {
      for (let i = 0; i < this.tabs.length; i++) {
        if (
          this.tabs[i].name === "" ||
          this.tabs[i].type === null ||
          this.tabs[i].feedbackform === undefined
        ) {
          this.tabs[i].roundIndex = i;
          this.checkRoundName = true;
        }
      }

      for (let index = 0; index < this.tabs.length; index++) {
        const tab = this.tabs[index];
        const duplicateIndex = this.tabs.findIndex(
          (t, i) => t.name === tab.name && i !== index
        );
        if (duplicateIndex !== -1) {
          // Found a duplicate name
          this.duplicateIndices.push(index);
          this.duplicateIndices.push(duplicateIndex);
        }
      }

      const tabNames = this.tabs.map((tab) => tab.name);

      this.hasDuplicateName = new Set(tabNames).size !== tabNames.length;

      if (
        this.hasDuplicateName ||
        this.tabs[this.selectedIndex].duplicateName
      ) {
        this.errorModal("Round name already exists");
      } else if (
        !this.$v.JobTitles.maxLength ||
        !this.$v.tabs.$each[this.selectedIndex].name.maxLength
      ) {
        this.errorModal(" Should not exceed 128 characters");
      } else if (this.$v.$invalid || this.checkRoundName) {
        this.errorModal("Please fill all the details");
      }
    },
  },
};
export default interviewProcessMixins;
